import clsx from 'clsx'
import type { ReactNode } from 'react'

import type { TIframeProps } from './Iframe.type'
import { isWhiteListed } from './urlContentWhiteList'

export const Iframe = ({ title, src, height: h, width, className, style, testID }: TIframeProps): ReactNode => {
  const match = /https:\/\/(\w+\.)?(\w+)\.\w+\//.exec(src)
  const iframeTitle = title || match?.[2] || ''
  const aspectRatio = width && h ? [width, h].join('/') : 'auto'

  const shouldSetFixedHeight = isWhiteListed(src)

  return (
    <iframe
      title={iframeTitle}
      src={src}
      // SoundCloud fails to initialize with an opaque origin.
      // Keep this exception covered by an integration test.
      // oxlint-disable-next-line react/iframe-missing-sandbox
      sandbox="allow-same-origin allow-scripts"
      allow="autoplay; encrypted-media; bluetooth"
      height={shouldSetFixedHeight ? '500px' : undefined}
      className={clsx('w-full', { 'h-[500px]': shouldSetFixedHeight }, className)}
      style={{ aspectRatio, ...style }}
      scrolling={shouldSetFixedHeight ? 'yes' : 'no'}
      data-test-id={testID}
    />
  )
}
